<script setup lang="ts">
import { ref } from 'vue'
import { Back } from '@/shared/icons'
import { message } from '@/shared/lib'
import { Icon } from '@/shared/ui/Icon'

import { useAccount } from '../model/useAccount'

const { stopImpersonating } = useAccount()

const leaving = ref(false)

async function click() {
  if (leaving.value) return
  leaving.value = true
  try {
    await stopImpersonating()
    // A full load, not a router push: the admin is a different application.
    window.location.href = `${import.meta.env.VITE_MAIN_APP_ADMIN}/adm/users`
  } catch {
    message.warning('Cant perform this action')
    leaving.value = false
  }
}
</script>

<template>
  <div class="get-back" @click="click">
    <Icon><Back /></Icon>
    Get back
  </div>
</template>

<style lang="scss" scoped>
.get-back {
  width: 100%;
}
</style>
